<template>
  <div>
    <div v-if="ShowSelectAll || ShowSearchInput" class="row align-items-center mb-2 mx-0">
      <div v-if="ShowSelectAll" class="col-md-3">
        <MdCheckBox
          v-bind:Label="$t('Shared.SelectAll')"
          v-bind:Name="'checklistbox2-select-all'"
          v-bind:ClassProp="'AlignCheck'"
          v-bind:CheckedValue="true"
          v-bind:UncheckedValue="false"
          v-bind:isReadOnly="!filteredOptions || filteredOptions.length === 0"
          v-model="selectAllState"
          v-on:change="onSelectAll"
        />
      </div>
      <div v-if="ShowSelectAll" class="col-md-3 mt-3">
        <span class="tableSelectedItems">
          <span class="selItemsVal">{{ selectedCount }}</span>
          {{ $t('claimbatchList.item') }}<span v-if="selectedCount !== 1">s</span>
          {{ $t('Shared.selected') }}
        </span>
      </div>
      <div v-if="ShowSearchInput" class="col-md-6 px-0" :class="{ 'ml-auto': !ShowSelectAll }">
        <div class="textlabel" :data-label="$t('Shared.SearchElements')">
          <div class="input-group" dir="ltr">
            <input
              type="text"
              class="form-control"
              :dir="dirInput"
              v-model="searchText"
              @keyup.enter="searchText = searchText"
            >
            <div class="input-group-append">
              <MdButton
                v-bind:Name="'btnsearchinput'"
                v-bind:VariantProp="'btn btn-sm search-attached'"
                v-bind:IconClass="'mdi mdi-magnify'"
                v-on:click="() => { searchText = searchText }"
              >
              </MdButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-bind:style="style" class="cutescroll">
      <b-input-group v-if="filteredOptions && filteredOptions.length > 0">
        <b-form-checkbox-group
            :key="checkboxGroupKey"
            v-model="selected"
            :options="filteredOptions"
            :style="this.columnCountStyle"
            name="flavour-2a"
            stacked
            @change="OnChange"
            :class="UseClassFlex ? 'd-flex' :''"
            :disabled="isReadOnly"
            :text-field="textField"
            :value-field="valueField"
            v-on:input="onInput"
          >
        </b-form-checkbox-group>
      </b-input-group>
      <div v-else class="empty-row-banner text-center my-2 w-100" style="align-self: flex-start; font-size: 1rem; line-height: 1.5;">{{ $t('MdTable.nRecShow') }}</div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
export default {
  name: 'MdCheckListBox2',
   props: {
     isReadOnly:       Boolean,
     value:            Array,
     TransDate:        String,
     Options:          Array,
     Tag:              String,
     isRequired:       Boolean,
     isValid:          Boolean,
     textField:        String,
     valueField:       String,
     Height:           String,
     columnCount:      Number,
     OnChangeProp:     Function,
     ignoreChangedEmit: Boolean,
     UseClassFlex:     Boolean,
     ShowSearchInput:  Boolean,
     ShowSelectAll:    Boolean,
   },

  computed: {
    filteredOptions() {
      if (!this.searchText || !this.Options) return this.Options;
      const term = this.searchText.toLowerCase();
      const field = this.textField || 'text';
      return this.Options.filter(opt => {
        const label = (opt[field] || '').toLowerCase();
        return label.includes(term);
      });
    },
    dirInput() {
      return this.$i18n && this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
    },
    selectedCount() {
      return (this.selected || []).length;
    },
  },

  data(){
      return{
        ControlMax:1,
        selected: this.value,
        searchText: '',
        selectAllState: false,
        updatingFromProp: false,
        isSelectingAll: false,
        checkboxGroupKey: 0,
        style:{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            justifyContent: 'flex-start',
            overflow:'auto',
            height: this.Height,
            padding: '5px 10px',
            border: 'solid 1px #e0e0e0 !important',
            borderRadius: '10px',
            borderColor: '#e0e0e0 !important',
            lineHeight: '1.55rem',
            color: '#666',
            fontSize: '0.875rem',
            fontWeight: '400',
        },
        columnCountStyle:this.columnCount != null ? "column-count: "+this.columnCount+"; gap: 15px;" : "column-count: 1; gap: 15px;"
      }
  },

  watch: {
    value(newValue) {
      if (this.isSelectingAll) return;
      this.updatingFromProp = true;
      this.selected = newValue ? newValue : [];
      this.$nextTick(() => {
        this.updatingFromProp = false;
      });
    },

    isValid(newValue) {
      this.setValid(newValue);
    },

    selected() {
      this.syncSelectAll();
    },

    filteredOptions() {
      this.syncSelectAll();
    },
  },

  methods:{
    syncSelectAll() {
      const opts = this.filteredOptions;
      if (!opts || opts.length === 0) { this.selectAllState = false; return; }
      const field = this.valueField || 'value';
      const sel = this.selected || [];
      this.selectAllState = opts.every(opt => sel.includes(opt[field]));
    },

    onSelectAll(value) {
      this.isSelectingAll = true;
      this.selectAllState = value;
      const field = this.valueField || 'value';
      const allValues = (this.filteredOptions || []).map(opt => opt[field]);
      if (value) {
        const current = this.selected || [];
        this.selected = [...new Set([...current, ...allValues])];
      } else {
        const remove = new Set(allValues);
        this.selected = (this.selected || []).filter(v => !remove.has(v));
      }
      this.checkboxGroupKey++;
      this.$emit('change', this.selected);
      this.$emit('input', this.selected);
      this.style.borderColor = this.selected.length === 0 && this.isRequired ? '#dc3545 !important' : '#e0e0e0 !important';
      if (this.OnChangeProp) {
        this.OnChangeProp(this.selected);
      }
      this.$nextTick(() => {
        this.isSelectingAll = false;
      });
    },

    OnChange(value){
      this.$emit('change', value);    
      this.$emit('input', value);
      this.style.borderColor = value.length == 0 && this.isRequired ? '#dc3545 !important' : '#e0e0e0 !important';
     
      if (this.OnChangeProp) {
        this.OnChangeProp(value);
      }
    },

    setValid(state){
      this.style.borderColor = state && this.isRequired ? '#e0e0e0 !important' : '#dc3545 !important' 
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '#e0e0e0 !important';
      }
    },

    onInput(){
       if (this.updatingFromProp) return;
       
      var changed = {
        "Changed":true,
        "ComponentName":this.Label,
        "Tag": this.Tag
      }
       
       if (!this.ignoreChangedEmit){
          EventBus.$emit('onChanged', changed);
       }
        
    }
  },

  mounted(){   
  }
};
</script>


